<template>
    <b-row>
        <b-col>
            <b-card>
                <b-form v-on:submit.prevent>
                    <b-row>
                        <b-col cols="12" class="text-left mb-2">
                            <b-badge :variant="statusVariant(this.status)">
                                <span v-if="this.status === 1">Waiting Approval</span>
                                <span v-else-if="this.status === 2">Approved</span>
                                <span v-else-if="this.status === 3">Rejected</span>
                            </b-badge>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group
                                    label="Image"
                                    label-for="image"
                                    >
                                        <b-img :src="photo" fluid alt="overtime photo" v-b-modal.modal-lg />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-modal
                            id="modal-lg"
                            ok-only
                            ok-title="close"
                            centered
                            size="lg"
                            title="Large Modal"
                            class="text-center"
                            >
                                <b-img id="photo" :src="photo" width="1000px" fluid alt="overtime photo" />
                            </b-modal>
                        </b-col>
                        <b-col md="8">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group
                                    label="Employee Name"
                                    label-for="employee_name"
                                    >
                                        <b-form-input
                                            id="employee_name"
                                            placeholder="Employee Name"
                                            v-model="form.name"
                                            disabled
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group
                                    label="Start At"
                                    label-for="start_at"
                                    >
                                        <flat-pickr
                                        v-model="form.start_at"
                                        class="form-control"
                                        :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                                        :disabled="this.status !== 1? true : false"
                                        required
                                        />
                                        <!-- <div class="mt-2">
                                        Value: '{{ form.start_at }}'
                                        </div> -->
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group
                                    label="End At"
                                    label-for="end_at"
                                    >
                                        <flat-pickr
                                        v-model="form.end_at"
                                        class="form-control"
                                        :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                                        :disabled="this.status !== 1? true : false"
                                        required
                                        />
                                        <!-- <div class="mt-2">
                                        Value: '{{ form.end_at }}'
                                        </div> -->
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group
                                    label="Duration"
                                    label-for="duration"
                                    >
                                        <b-form-input
                                            id="duration"
                                            placeholder="Duration"
                                            v-model="form.duration"
                                            disabled
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group
                                    label="Description"
                                    label-for="description"
                                    >
                                        <b-form-textarea
                                            id="description"
                                            placeholder="Description"
                                            v-model="form.description"
                                            disabled
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6" v-if="this.status === 3">
                                    <b-form-group
                                    label="Reject Reason"
                                    label-for="reject_reason"
                                    >
                                    <div>
                                        <b-form-textarea
                                            id="reject_reason"
                                            placeholder="Reject Reason"
                                            v-model="form.reject_reason"
                                            disabled
                                        />

                                    </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>

                        <!-- submit and reset -->
                        <b-col md="12" class="mt-2" v-if="status === 1">
                            <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="primary"
                            class="mr-1"
                            @click="updateOvertime()"
                            block
                            >
                            Update
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
        
        <b-col cols="12" md="12" class="mt-0" v-if="status === 1">
            <b-row>
                <b-col>
                    <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="danger"
                    class="mr-1"
                    block
                    v-b-modal.modal-reject
                    >
                    Reject
                    </b-button>
                </b-col>
                <b-col>
                    <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="success"
                    class="mr-1"
                    block
                    @click="approve()"
                    >
                    Approve
                    </b-button>
                </b-col>
            </b-row>
        </b-col>

        <!-- modal change password -->
        <b-modal
        id="modal-reject"
        title="Reject Form"
        ok-title="Reject"
        cancel-variant="outline-secondary"
        hide-footer
        >
            <validation-observer ref="loginValidation">
            <b-form ref="form" @submit.prevent>
                <b-form-group
                :state="errors"
                label="Reject Reason"
                label-for="reject"
                invalid-feedback="Reject Reason required"
                >
                    <validation-provider
                    #default="{ errors }"
                    name="reject"
                    rules="required"
                    >
                        <b-form-input
                            id="reject"
                            name="reject"
                            type="text"
                            v-model="form.reject_reason"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Reject Reason"
                            required="required"
                        />
                        <small class="text-danger">{{ errors[0] || errMessage }}</small>
                    </validation-provider>
                </b-form-group>

                <b-row>
                    <b-col>
                        <b-button
                            class="mt-3"
                            type="submit"
                            variant="danger"
                            block
                            @click="reject()"
                        >
                            Reject
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
            </validation-observer>
        </b-modal>
        <!-- end modal change password -->
    </b-row>
</template>

<script>
import {
    BFormTextarea, BBadge, BImg, BFormTimepicker, BFormDatepicker, BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from "@themeConfig"
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    LMap, LTileLayer, LMarker, LPopup
} from 'vue2-leaflet'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        ToastificationContent,
        flatPickr,
        BFormTextarea,
        BBadge,
        ValidationProvider,
        ValidationObserver,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        BImg,
        BFormTimepicker,
        BFormDatepicker,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        draggable,
        Prism
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            form: {
                name: '',
                start_at: null,
                end_at: null,
                duration: null,
                description: '',
                reject_reason: ''
            },
            photo: '',
            status: '',
            errors: '',
            errMessage: ''
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                1 : 'light-warning',
                2 : 'light-success',
                3 : 'light-danger'
            }

            return status => statusColor[status]
        },
    },
    setup() {
        // App Name
        const { baseUrl, apiUrl } = $themeConfig.app;
        return {
            baseUrl,
            apiUrl
        };
    },
    created() {
        this.getDetails()
    },
    methods: {
        getDetails() {
            const id = this.$route.params.id
            this.$http
            .get('overtimes/' +id)
            .then((response) => {
                // console.log(response.data.data)
                this.status = response.data.data.status
                this.form.name = response.data.data.user_name
                this.form.start_at = response.data.data.start_at
                this.form.end_at = response.data.data.end_at
                this.form.duration = response.data.data.duration
                this.form.description = response.data.data.description
                const { baseUrl } = $themeConfig.app
                this.photo = baseUrl
                this.photo += 'storage/overtime/'
                this.photo += response.data.data.image
                this.form.reject_reason = response.data.data.reject_reason
            }).catch((err) => {
                console.log(err.response)
            });
        },
        setImage: function (file) {
            this.hasImage = true
            this.image = file
        },
        updateOvertime() {
            const id = this.$route.params.id
            this.$http
            .post('overtimes/'+id+'/update', {
                'name': this.form.name,
                'start_at': this.form.start_at,
                'end_at': this.form.end_at,
                'description': this.form.description
            })
            .then((response) => {
                // console.log(response.data.data)
                this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Success update Overtime',
                            variant: 'success',
                        },
                    })
                location.href = "/overtimes"
            }).catch((err) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(err.response)
            });
        },
        approve() {
            const id = this.$route.params.id
            this.$http
            .post('overtimes/'+id+'/approve')
            .then((response) => {
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Overtime Approved',
                        variant: 'success',
                    },
                })
                location.href = "/overtimes"
            }).catch((err) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(err.response)
            });
        },
        reject() {
            const id = this.$route.params.id
            this.$http
            .post('overtimes/'+id+'/reject', {
                'reject_reason': this.form.reject_reason
            })
            .then((response) => {
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Overtime Rejected',
                        variant: 'danger',
                    },
                })
                location.href = "/overtimes"
            }).catch((err) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(err.response)
            });
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>